import { useEffect, useState } from "react";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { LFTableV3 } from "../../../../../common/components/LFTable/LFTableV3";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { ColumnItem } from "../../../../../common/models/table";
import { ActionsKey } from "../../../../../common/models/Actions";
import { ShiftingOperationsService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import dayjs from "dayjs";
import { useShiftingOperationsListState, useShiftingOperationsStore } from "../../../store/ShiftingStore";
import ShiftingOperationsForm from "./components/ShiftingOperationsForm";
import { useLocation } from "react-router";
import ShiftingOperationsDetails from "./components/ShiftingOperationsDetails";
import { Tag } from "antd";
import { getShiftingStatusTagData } from "../../../../../utilities/StatusShiftingTag";


const cols: ColumnItem[] = [
  {
    key: "state",
    title: "Etat",
    dataIndex: "state",
    show: true,
    render: (state: any) => {
      const { label, color } = getShiftingStatusTagData(state?.id);
      return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <Tag color={color}>{label}</Tag>
        </div>
      );
    },
  },
  {
    key: "loadType",
    title: "Marchandise",
    dataIndex: "loadType",
    show: true,
    render: (value: any) => value?.name,
  },
  {
    key: "shiftingType",
    title: "Type de shifting",
    dataIndex: "shiftingType",
    isCanSort: true,
    show: true,
    render: (value: any) => value?.name,
  },
  {
    key: "uniqueIdentifier",
    title: "Identifiant",
    dataIndex: "uniqueIdentifier",
    isCanSort: true,
    show: true,
  },
  {
    key: "tonnage",
    title: "Tonnage (T)",
    dataIndex: "tonnage",
    isCanSort: true,
    show: true,
  },
  {
    key: "loadFillingStatus",
    title: "État",
    dataIndex: "loadFillingStatus",
    show: true,
    render: (value: any) => value?.name,
  },
  {
    key: "loadUnit",
    title: "Nature",
    dataIndex: "loadUnit",
    isCanSort: true,
    show: true,
  },
  {
    key: "loadProperty",
    title: "Type",
    dataIndex: "loadProperty",
    show: true,
  },
  {
    key: "startAt",
    title: "Date",
    dataIndex: "startAt",
    render: (value: any) =>
      value ? dayjs(value, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YY ") : "-",
    isCanSort: false,
    show: true,
  },
  {
    key: "startAt",
    title: "Heure de début",
    dataIndex: "startAt",
    render: (value: any) =>
      value ? dayjs(value, "DD/MM/YYYY HH:mm:ss").format("HH:mm") : "-",
    isCanSort: false,
    show: true,
  },
  {
    key: "endAt",
    title: "Heure de fin",
    dataIndex: "endAt",
    render: (value: any) =>
      value ? dayjs(value, "DD/MM/YYYY HH:mm:ss").format("HH:mm") : "-",
    isCanSort: false,
    show: true,
  },
  {
    key: "isBargeUsed",
    title: "Chaland",
    dataIndex: "isBargeUsed",
    isCanSort: true,
    show: true,
    render: (value: boolean) => value ? "OUI" : "NON",
  },
  {
    key: "bargeMaterial",
    title: "Référence chaland",
    dataIndex: "bargeMaterial",
    show: true,
    render: (value: any) => value ? value?.reference : "-",
  },
  {
    key: "duration",
    title: "Durée (heures)",
    dataIndex: "duration",
    show: true,
  },
];

function ShiftingOperationsList() {

  const {
    setShiftingList,
    shiftingList,
    actioned,
    totalItems,
    setActioned,
  } = useShiftingOperationsStore();
  const { pageState, setPageState, resetPageState } =
    useShiftingOperationsListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const movementId = queryParams.get("movment");

  useEffect(() => {
    if (movementId) {
      fetchAllShiftingOperations({ "movement.id": movementId, ...pageState });
    }
  }, [pageState, movementId]);
  
    useEffect(() => {
      if (!isShowForm) {
        setActioned({ action: "no", data: null });
      }
    }, [isShowForm]);
  
    const onActionClick = (item: any, action: ActionsKey) => {

      const id = parseInt(item?.["@id"]?.split("/").pop() || "", 10);

      if (action === "delete") {
        onDeleteHandler(id);
      } else {
        getOne(id, action);
      }
    };
  
    const onShowAddHandler = () => {
      setIsShowForm((prev: boolean) => !prev);
    };
  
    const getOne = async (id: number, action: any) => {
      try {
        setIsLoading(true);
        const res = await ShiftingOperationsService.getShiftingOperationsById(id);
        if (res?.status === HttpStatusCode.Ok) {
          setActioned({
            data: {
              ...res?.data,
            },
            action,
          });
        }
        onShowAddHandler();
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const onDeleteHandler = async (id: number) => {
      try {
        setIsLoading(true);
        const res = await ShiftingOperationsService.deleteShiftingOperations(id);
        if (res?.status === HttpStatusCode.NoContent) {
          fetchAllShiftingOperations({"movement.id": movementId, ...pageState});
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const fetchAllShiftingOperations = async (params?: any) => {
      try {
        setIsLoading(true);
        const res = await ShiftingOperationsService.getAllShiftingOperations(params);
        if (res?.status === HttpStatusCode.Ok) {
          setShiftingList(res.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const onFinishAction = () => {
      //resetPageState();
      onShowAddHandler();
      setPageState({...pageState});
    };
  
    const handleSetParams = (params: any) => {
      setPageState({
        ...params,
      });
    };

  return (
    <>
      <Loader isLoading={isLoading} />

      <LFTableV3
        columns={cols}
        params={pageState}
        data={shiftingList}
        onAction={onActionClick}
        isCanDelete={() => true}
        isCanShow={() => true}
        isCanEdit={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        onChangePage={handleSetParams}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
      />

        {/* Drawer section  */}
        {isShowForm ? (
            <CustomDrawer
            isOpen={isShowForm}
            onClose={onShowAddHandler}
            title={actioned?.action === "update" ? "Modification" : "Détails"}
            width={"75%"}
            >
            {/* <ShiftingOperationsForm
                 onFinish={onFinishAction}
                {...(actioned?.action === "update"
                ? {
                    initialValue: actioned?.data,
                    }
                : {})}
            /> */}
            {actioned?.action === "update" 
            ? 
            <ShiftingOperationsForm
            onFinish={onFinishAction}
                {...({
                    initialValue: actioned?.data,
                    })} 
            /> :
            <ShiftingOperationsDetails
                {...(actioned?.action === "read"
                ? {
                    initialValue: actioned?.data,
                    }
                : {})}
            />}
            </CustomDrawer>
        ) : (
            ""
        )} 
    </>
  )
}

export default ShiftingOperationsList